import { stage, trackWithDefaultStage } from "@flights/et-universal";
import { BLACK_FRIDAY_EXLUDED_COUNTRIES } from "../../../constants";
import { isOfMetaOrigin, isOfPPCOrigin } from "../../../utils/marketing-url-params";
import useGlobalContext from "../../../hooks/useGlobalContext";
import useProfiler from "../../../hooks/useProfiler";

const useBlackFridayExp = (): boolean => {
  const { ipCountry = "" } = useGlobalContext();
  const { isDesktop } = useProfiler();

  const isBlackFridayEligble =
    !isOfPPCOrigin() && !isOfMetaOrigin() && !BLACK_FRIDAY_EXLUDED_COUNTRIES.includes(ipCountry.toLowerCase());

  const isBlackFridayExp =
    isBlackFridayEligble && !!trackWithDefaultStage("flights_web_cat_black_friday_index_2025", 1);

  if (isDesktop() && isBlackFridayEligble) {
    stage("flights_web_cat_black_friday_index_2025", 2);
  }

  if (!isDesktop() && isBlackFridayEligble) {
    stage("flights_web_cat_black_friday_index_2025", 3);
  }

  return isBlackFridayExp;
};

export default useBlackFridayExp;
